export const PATHWAYS = ["Arts", "Humanities", "STEM", "Wellness"] as const;
export type Pathway = (typeof PATHWAYS)[number];

export const USER_ROLES = [
  "sys-admin",
  "administrator",
  "teacher",
  "student",
] as const;
export type UserRole = (typeof USER_ROLES)[number];

export const GRADE_OPTIONS = [5, 6, 7, 8, 9, 10, 11, 12] as const;
